import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { GlobalSearch } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${GlobalSearch.Pages.SEARCH}`,
    name: GlobalSearch.Pages.SEARCH,
    component: () => import(/* webpackChunkName: "leads" */ './views/GlobalSearch.vue'),
    meta: {
      access_roles: RouteRoles[GlobalSearch.Pages.SEARCH],
    },
  },
];

export default routes;
